import React from 'react'
import ReactDOM from 'react-dom'
import './styles/main.scss'
import App from './App'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/mapbox-gl/dist/mapbox-gl.css'

ReactDOM.render(<App />, document.getElementById('root'))